<script setup>
import { computed } from 'vue'

import { getI18n } from '@/plugins/i18n'
import { useCurrency } from '@/composables/currency'
import { formatDuration, reportPeriodShortLabel, useReportSubject } from '@/composables/report'
import { signalToneEnum, signalToneColor } from '@/composables/dashboard-kpi'
import { useWebSiteStore } from '@/stores/web-site.store'

import ListItem from '@/components/shared/ListItem.vue'

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
})

const emit = defineEmits(['click'])

const i18n = getI18n()
const webSiteStore = useWebSiteStore()
const { getCurrencyString } = useCurrency()
const { subjectLabel, subjectIcon, subjectChips } = useReportSubject()
const pendingCount = computed(() => (props.item.pending_changed_count || 0) + (props.item.pending_deleted_count || 0))
const captionChips = computed(() => [
  ...subjectChips(props.item.subject),
  ...(pendingCount.value
    ? [{ id: 'pending-changes', name: i18n.t('common.report.pendingChangedCount', pendingCount.value), color: signalToneColor(signalToneEnum.ATTENTION), textColor: 'white' }]
    : []),
])
const expenses = (item) => (item.total_expenses_reference ? getCurrencyString(+item.total_expenses_reference, webSiteStore.getDefaultCurrency()?.code) : '')
const hours = (item) => (item.total_net_minutes ? `${formatDuration(item.total_net_minutes)} h` : '')
</script>

<template>
  <q-item>
    <list-item
      class="q-pa-sm"
      :avatar="props.item.subject_avatar"
      :avatar-icon="subjectIcon(props.item)"
      avatar-icon-color="primary"
      :label="props.item.name"
      :caption-chips="captionChips"
      :right-label="hours(props.item) || expenses(props.item)"
      :right-caption="hours(props.item) ? expenses(props.item) : ''"
      dense
      clickable
      @click="emit('click', props.item)"
    >
      <template #caption>
        <div class="ellipsis">{{ [subjectLabel(props.item), reportPeriodShortLabel(props.item)].filter(Boolean).join(' · ') }}</div>
      </template>
    </list-item>
  </q-item>
</template>
